import apiService from '../http.service';
import { appConfig, APP_TYPES } from '../../app.config';
// import { generalCalculationDefaultOptions } from '../../object-view/generators/general-calculation';
// import { bracketAttachmentDefaultOptions } from '../../object-view/generators/bracket-attachment';
// import { safetyBarrierDefaultOptions } from '../../object-view/generators/safety-barrier';

class ApplicationTabService {

  getMaterialNames() {
    return apiService.get({ query: appConfig.path.MATERIAL_NAMES });
  }

  getProfileTypes(appType) {
    if (appType === APP_TYPES.REBAR_REINFORCEMENT || appType === APP_TYPES.WOOD_CONNECTION) {
      return Promise.resolve();
    }

    const profileTypeMap = {
      [APP_TYPES.GENERAL_CALCULATION]: appConfig.path.PROFILE_TYPES,
      [APP_TYPES.BRACKET_ATTACHMENT]: appConfig.path.PROFILE_TYPES,
      [APP_TYPES.SAFETY_BARRIER]: appConfig.path.SAFETY_BARRIER_PROFILES
    };

    return apiService.get({ query: profileTypeMap[appType] });
  }

  getProfileSizes(profile) {
    return apiService.get({ query: `${appConfig.path.PROFILE_SIZES}?profTypeInternalName=${profile}`});
  }

  getProfileShape(type, size) {
    return apiService.get({
      query: `${appConfig.path.BEAM_PROFILE_SHAPE}?profTypeInternalName=${type}&profSizeInternalName=${size}`
    });
  }

  getPredefinedBasePlates(plateConfig) {
    return apiService.post({
      query: appConfig.path.GET_SB_PREDEFINED_BASE_PLATES,
      data: { "basePlateData": plateConfig } 
    });
  }

  getPredefinedBasePlate(basePlateId) {
    return apiService.get({
      query: `${appConfig.path.GET_SB_PREDEFINED_BASE_PLATE}?basePlateId=${basePlateId}`
    });
  }
  
  getPredefinedBasePlateImage(basePlateId) {
    return apiService.get({
      query: `${appConfig.path.GET_SB_PREDEFINED_BASE_PLATE_IMAGE}?basePlateId=${basePlateId}`
    });
  }
  
}

export default new ApplicationTabService();



// WEBPACK FOOTER //
// ./src/services/requests/application-tab.service.js